import { GridCellEventArgs as GridCellEventArgs_internal } from "./GridCellEventArgs";
import { IgrDateTimeCellInfo } from "./igr-date-time-cell-info";
import { IgrImageCellInfo } from "./igr-image-cell-info";
import { IgrNumericCellInfo } from "./igr-numeric-cell-info";
import { IgrRowSeparatorInfo } from "./igr-row-separator-info";
import { IgrSectionHeaderCellInfo } from "./igr-section-header-cell-info";
import { IgrTemplateCellInfo } from "./igr-template-cell-info";
import { IgrTemplateHeaderCellInfo } from "./igr-template-header-cell-info";
import { IgrTemplateSectionHeaderCellInfo } from "./igr-template-section-header-cell-info";
import { IgrTextCellInfo } from "./igr-text-cell-info";
import { IgrTextHeaderCellInfo } from "./igr-text-header-cell-info";
/**
 * Information about the cell in context.
*/
var IgrGridCellEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridCellEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridCellEventArgs.prototype.createImplementation = function () {
        return new GridCellEventArgs_internal();
    };
    Object.defineProperty(IgrGridCellEventArgs.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridCellEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridCellEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridCellEventArgs.prototype, "cellInfo", {
        /**
         * The backing information for the current cell.
        */
        get: function () {
            if (this.i.cellInfo == null) {
                return null;
            }
            if (!this.i.cellInfo.externalObject) {
                var ext = null;
                switch (this.i.cellInfo.$type.name) {
                    case "DateTimeCellModel":
                        ext = new IgrDateTimeCellInfo();
                        break;
                    case "ImageCellModel":
                        ext = new IgrImageCellInfo();
                        break;
                    case "NumericCellModel":
                        ext = new IgrNumericCellInfo();
                        break;
                    case "RowSeparatorModel":
                        ext = new IgrRowSeparatorInfo();
                        break;
                    case "SectionHeaderCellModel":
                        ext = new IgrSectionHeaderCellInfo();
                        break;
                    case "TemplateCellModel":
                        ext = new IgrTemplateCellInfo();
                        break;
                    case "TemplateHeaderCellModel":
                        ext = new IgrTemplateHeaderCellInfo();
                        break;
                    case "TemplateSectionHeaderCellModel":
                        ext = new IgrTemplateSectionHeaderCellInfo();
                        break;
                    case "TextCellModel":
                        ext = new IgrTextCellInfo();
                        break;
                    case "TextHeaderCellModel":
                        ext = new IgrTextHeaderCellInfo();
                        break;
                }
                ext._implementation = this.i.cellInfo;
                this.i.cellInfo.externalObject = ext;
            }
            return this.i.cellInfo.externalObject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellEventArgs.prototype, "grid", {
        /**
     * Gets the grid owning the cell.
    */
        get: function () {
            if (this.i.grid == null) {
                return null;
            }
            return this.i.grid.externalObject;
        },
        set: function (v) {
            v == null ? this.i.grid = null : this.i.grid = v.i;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridCellEventArgs;
}());
export { IgrGridCellEventArgs };
//# sourceMappingURL=igr-grid-cell-event-args.js.map
